"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ArrayField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _Autocomplete = require("@mui/material/Autocomplete");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["input", "label", "meta", "isMulti", "name", "clearOnBlur", "filter"];
var useStyles = (0, _makeStyles.default)({
  autoComplete: {
    padding: '6px 9px 5px 9px !important'
  }
});
var isEmptyFieldValue = function isEmptyFieldValue(value) {
  return value === undefined || value === null || value === '' || Array.isArray(value) && !value.length;
};
function ArrayField(_ref) {
  var input = _ref.input,
    label = _ref.label,
    meta = _ref.meta,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? true : _ref$isMulti,
    name = _ref.name,
    _ref$clearOnBlur = _ref.clearOnBlur,
    clearOnBlur = _ref$clearOnBlur === void 0 ? true : _ref$clearOnBlur,
    _ref$filter = _ref.filter,
    filter = _ref$filter === void 0 ? (0, _Autocomplete.createFilterOptions)() : _ref$filter,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  var value = input.value,
    onChange = input.onChange;
  var _meta$data = meta.data,
    data = _meta$data === void 0 ? {} : _meta$data,
    inputError = meta.error,
    touched = meta.touched,
    warning = meta.warning,
    modifiedSinceLastSubmit = meta.modifiedSinceLastSubmit;
  var error = inputError || !modifiedSinceLastSubmit && data.submitError;
  var handleChange = function handleChange(event, option, reason) {
    if (reason === 'createOption' || reason === 'selectOption' || reason === 'removeOption') {
      onChange(option);
    } else if (reason === 'clear') {
      onChange(isMulti ? [] : null);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Autocomplete, (0, _extends2.default)({
    clearOnBlur: clearOnBlur,
    freeSolo: true,
    openOnFocus: true,
    options: [],
    selectOnFocus: true
  }, rest, {
    classes: {
      inputRoot: classes.autoComplete
    },
    filterOptions: function filterOptions(options, params) {
      var filtered = filter(options, params);
      var inputValue = params.inputValue;
      return !isEmptyFieldValue(inputValue) && !options.includes(inputValue) ? [inputValue].concat((0, _toConsumableArray2.default)(filtered)) : filtered;
    },
    multiple: isMulti,
    onChange: handleChange,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, params, {
        error: touched && !!(error || warning),
        label: label,
        variant: "outlined"
      }));
    },
    value: value
  }));
}